module.exports = __webpack_public_path__ + "img/fi-rr-cloud-upload.d1ed7c0b.svg";